module.exports = __webpack_public_path__ + "img/personnel_management.79ce36da.png";